import React, { useEffect, useState } from "react";
import {
  Table,
  Empty,
  Row,
  Col,
  Drawer,
  notification,
  Popconfirm,
  Button,
} from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  BarsOutlined,
} from "@ant-design/icons";
import ManualTransactionTypeUpdate from "../Forms/ManualTransactionTypeUpdate";
import ManualTransactionTypeAdd from "../Forms/ManualTransactionTypeAdd";
import { useMediaQuery } from "react-responsive";
import RequestHandler from "../../util/RequestHandler";

const openNotificationWithIconDelete = (type) => {
  notification[type]({
    message: "BAŞARILI",
    description: "Silme işlemi başarı ile gerçekleşti.",
    duration: 2,
  });
};
const openNotificationWithIconWarningDelete = (type) => {
  notification[type]({
    message: "HATA",
    description: "Silme işlemi sırasında bir hata oluştu.",
    duration: 2,
  });
};
const ManualTransactionTypeList = () => {
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-device-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({ query: "(max-device-width: 1224px)" });

  const [manualTransactionTypes, setManualTransactionTypes] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [dataState, setDataState] = useState([{ skip: 0, take: 10 }]);
  const [manualTransactionTypeId, setManualTransactionTypeId] = useState("");
  const [Name, setName] = useState("");
  const [visible, setVisible] = useState(false);
  const [take, setTake] = useState(20);
  const [skip, setSkip] = useState(0);
  const [visibleUpdate, setVisibleUpdate] = useState(false);

  useEffect(() => {
    setManualTransactionTypes({
      ...manualTransactionTypes,
      loading: true,
    });

    RequestHandler.get(`/ManualTransactionType?$count=true&$skip=${skip}&$top=${take}`).then((response) => {
      setManualTransactionTypes({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  }, [setDataState, skip, setSkip]);

  const showDrawerUpdate = (value) => {
    RequestHandler.get(`/ManualTransactionType/GetById/${value}`).then((response) => {
      setName(response.name);
      setManualTransactionTypeId(value);
      setVisibleUpdate(true);
    });
  };

  const reList = () => {
    setManualTransactionTypes({
      ...manualTransactionTypes,
      loading: true,
    });

    RequestHandler.get(`/ManualTransactionType?$count=true&$skip=${skip}&$top=${take}`).then((response) => {
      setManualTransactionTypes({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const getData = (val) => {
    if (val === "success") {
      reList();
      setVisibleUpdate(false);
      setVisible(false);
    }
  };
  const onClose = () => {
    setVisibleUpdate(false);
    setVisible(false);
  };
  const onCloseUpdate = () => {
    setVisibleUpdate(false);
  };
  const handleDelete = (key) => {
    RequestHandler.delete(`/ManualTransactionType?id=${key}`, undefined, false, { rawResponse: true }).then((res) => {
      if (res.status == 204 || res.status == 200) {
        openNotificationWithIconDelete("success");
        setManualTransactionTypes({
          data: manualTransactionTypes.data.filter((item) => item.id !== key),
          total: manualTransactionTypes.total - 1,
          loading: false,
        });
        if (
          manualTransactionTypes.data.filter((item) => item.id !== key)
            .length == 0
        ) {
          window.location.reload();
        }
      } else {
        openNotificationWithIconWarningDelete("error");
      }
    });
  };

  const paging = (p) => {
    setDataState((prevState) => {
      prevState.skip = (p.current - 1) * 20;
      setTake(p.pageSize);
      setSkip(prevState.skip);
      return {
        prevState,
      };
    });
  };

  const columns = [
    {
      title: "Tip Adı",
      dataIndex: "name",
      width: "10%",
      key: "name",
    },
    {
      title: "",
      dataIndex: "operation",
      width: "10%",
      align: "right",
      render: (text, record) =>
        manualTransactionTypes.data.length >= 1 && record.name != "Diğer" ? (
          <a
            onClick={() => {
              showDrawerUpdate(record.id);
            }}
            style={{ color: "orange", fontSize: "130%" }}
          >
            <EditOutlined />
          </a>
        ) : null,
    },
    {
      title: "",
      dataIndex: "operation",
      width: "1%",
      render: (text, record) =>
        manualTransactionTypes.data.length >= 1 && record.name != "Diğer" ? (
          <Popconfirm
            title="Silmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleDelete(record.id)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <DeleteOutlined />
            </a>
          </Popconfirm>
        ) : null,
    },
  ];

  return (
    <div>
      <Row>
        {isTabletOrMobileDevice && (
          <>
            <Col span={12}>
              <p style={{ fontSize: "110%" }}>
                <BarsOutlined /> ELDEN İŞLEM TİPLERİ
              </p>
              <hr></hr>
              <br></br>
            </Col>
            <Col span={12}>
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  setVisible(true);
                }}
              >
                <PlusOutlined /> Elden İşlem Tipi Ekle
              </Button>
            </Col>
          </>
        )}
        {isDesktopOrLaptop && (
          <>
            <Col span={20}>
              <p style={{ fontSize: "120%", marginTop: -9 }}>
                <BarsOutlined /> ELDEN İŞLEM TİPLERİ
              </p>
            </Col>
            <Col span={4}>
              <Button
                type="primary"
                onClick={() => {
                  setVisible(true);
                }}
              >
                <PlusOutlined /> Elden İşlem Tipi Ekle
              </Button>
            </Col>
          </>
        )}
      </Row>
      <Drawer
        title="Elden İşlem Tipi Güncelle"
        width={241}
        onClose={onCloseUpdate}
        visible={visibleUpdate}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <ManualTransactionTypeUpdate
          Name={Name}
          sendDataForUpdate={getData}
          manualTransactionTypeId={manualTransactionTypeId}
        />
      </Drawer>
      <Drawer
        title="Elden İşlem Tipi Ekle"
        width={241}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={<div style={{ textAlign: "right" }}></div>}
      >
        <ManualTransactionTypeAdd />
      </Drawer>
      <Row>
        {isDesktopOrLaptop && (
          <>
            <Col span={2}></Col>
            <Col span={20}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%" }}
                size="small"
                rowKey="Id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                pagination={{
                  pageSize: 20,
                  total: manualTransactionTypes.total,
                }}
                dataSource={manualTransactionTypes.data}
                loading={manualTransactionTypes.loading}
              />
            </Col>
            <Col span={2}></Col>
          </>
        )}
        {isTabletOrMobileDevice && (
          <>
            <Col span={24}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", width: "100%", maxHeight: "100%" }}
                size="small"
                rowKey="Id"
                filterable={true}
                sortable={true}
                pageable={true}
                onChange={paging}
                pagination={{
                  pageSizeOptions: ["15", "25", "50", "100"],
                  defaultPageSize: take,
                  total: manualTransactionTypes.total,
                }}
                dataSource={manualTransactionTypes.data}
                loading={manualTransactionTypes.loading}
              />
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};

export default ManualTransactionTypeList;
